export const FACEBOOK_SDK_SCRIPT_ID = 'facebook-jssdk'

export const FACEBOOK_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js'

export const META_EMBEDDED_SIGNUP_TIMEOUT_MS = 25000

export const META_EMBEDDED_SIGNUP_ERROR_NOTIFICATION =
  'Meta WhatsApp connection could not be completed. Please try again.'

export const META_EMBEDDED_SIGNUP_CANCELLED_NOTIFICATION =
  'Meta WhatsApp connection was cancelled.'

export const META_EMBEDDED_SIGNUP_TIMEOUT_NOTIFICATION =
  'Meta WhatsApp connection timed out. Please try again.'

export const META_EMBEDDED_SIGNUP_UNAVAILABLE_NOTIFICATION =
  'Meta WhatsApp connection is unavailable right now. Please try again.'

export const META_EMBEDDED_SIGNUP_SUCCESS_EVENTS = new Set([
  'FINISH',
  'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING',
  'FINISH_OBO_MIGRATION',
  'FINISH_GRANT_ONLY_API_ACCESS',
])

export const META_EMBEDDED_SIGNUP_LOGIN_EXTRAS = {
  setup: {},
  featureType: 'whatsapp_business_app_onboarding',
  sessionInfoVersion: '3',
}
